import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppHttpService } from 'src/app/app-http.service';
import { ModalMensageComponent } from '../modal-mensage/modal-mensage.component';
import { text } from "../../../../config/text";

@Component({
  selector: 'app-newpassword',
  templateUrl: './newpassword.component.html',
  styleUrls: ['./newpassword.component.scss']
})
export class NewpasswordComponent implements OnInit {
  pass: String = "";
  passConfirm: String = "";
  msgAux: String = "";
  href: string = "";
  URL_BACK: string = localStorage['URL_BACK'] == null ? "/" : localStorage['URL_BACK'];
  textoToolTip:  String = "";
  listRule: any;
  hideTooltip: boolean = false;
  restrictWords!: string;

  constructor(public dialog: MatDialog, public http: AppHttpService, private router: Router) { }
  ngOnInit(): void {
    this.http.AccesRule(localStorage["userId"]).subscribe((data: any) => {
      this.listRule = data;
      this.restrictWords = data.passwordForbiddenWords.join(', ');
    }, ((error: any) => {
    }));
  }

  ngAfterContentInit(): void{    
  }

  openDialog() {
    if (this.pass == this.passConfirm) {
      this.http.postNewPass(localStorage["userId"], localStorage["validateCode"], this.pass).subscribe((data: any) => {
        const dialogRef = this.dialog.open(ModalMensageComponent,
          {
            data: {
              msg: text.senha_sucesso
            }
          });

        dialogRef.afterClosed().subscribe(result => {
          window.location.assign(this.URL_BACK);
        });
      }, ((error: any) => {
        this.msgAux = "";

        if (error.error.length > 0) {
          if(error.error[0].message == ""){
            const dialogRef = this.dialog.open(NewPasswordDialog,
              {
                data: error.error[0],
                width: '400px'
              });
          }
          else{
            this.msgAux = error.error[0].message;
            const dialogRef = this.dialog.open(ModalMensageComponent,
              {
                data: {
                  msg: this.msgAux
                }
              });
            dialogRef.afterClosed().subscribe(result => {
              if (this.msgAux == "Código de verificación invalido") {
                this.router.navigate(["validatecode"]);
              }
            });
          }
        }
        else {
          if(error.error.message == ''){
            const dialogRef = this.dialog.open(NewPasswordDialog,
              {
                data: error.error,
                width: '400px'
              });
          }
          else{
            this.msgAux = error.error.message;
          }
        }
      }));
    }
    else {
      const dialogRef = this.dialog.open(ModalMensageComponent,
        {
          data: {
            msg: text.senha_diferentes
          }
        });
    }
  }

  hide: boolean = true;
  myFunction() {
    this.hide = !this.hide;
  }
}

@Component({
  selector: 'newpassword.component-dialog',
  templateUrl: 'newpassword.component-dialog.html',
  styleUrls: ['./newpassword.component.scss']
})
export class NewPasswordDialog {
  constructor(public dialogRef: MatDialogRef<NewPasswordDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
